import { FC, lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { ROUTE_PATHS } from "src/config";
import { LoadingPlaceholder } from "../shared/components";
import ProtectedRoute from "../shared/components/protected-route/protected-route";

const AdminModuleRouter = lazy(
  () => import("../admin-portal/admin-portal.routes")
);

const MediaModuleRouter = lazy(
  () => import("../media-player/media-player.routes")
);

const AuthModuleRouter = lazy(() => import("../auth/routes"));

export const UIAppRoutes: FC = () => {
  return (
    <Routes>
      <Route
        path="auth/*"
        element={
          <Suspense fallback={<LoadingPlaceholder />}>
            <AuthModuleRouter />
          </Suspense>
        }
      />
      <Route
        path="media/*"
        element={
          <Suspense fallback={<LoadingPlaceholder />}>
            <MediaModuleRouter />
          </Suspense>
        }
      />
      <Route
        path="admin-portal/*"
        element={
          <Suspense fallback={<LoadingPlaceholder />}>
            <ProtectedRoute>
              <AdminModuleRouter />
            </ProtectedRoute>
          </Suspense>
        }
      />
      <Route
        path="*"
        element={
          <Navigate to={`/admin-portal/${ROUTE_PATHS.USERS_LIST}`} replace />
        }
      />
    </Routes>
  );
};
